module.exports = __webpack_public_path__ + "static/media/DihorOtok_Main.c0d219e0.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DihorOtok_Main.webp
// module id = ./src/assets/DihorOtok_Main.webp
// module chunks = 0